// extracted by mini-css-extract-plugin
module.exports = {"icon":"Style_icon__ALl62","modal":"Style_modal__32LbB","volba":"Style_volba__3Qncs"};